// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadSection_container__d8kZA","wrapper":"DownloadSection_wrapper__V5hB_"};